import "./PinGenSection.css";
import { BottomSection } from "../../BottomSection/BottomSection";
import { TopSection } from "../../TopSection/TopSection";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useState } from "react";

export const PinGenSection = ({userData,setRegistrationStep,isRegisterationTrue,setForgotPasswordStep,authToken}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [error ,setErrors] = useState('');
  const [loading,setLoading] = useState(false);
  const onSubmit = (data) => {
    if(data?.newPin!=data?.confirmPin){
      setErrors('Pin and confirm pin must be same.');
      setTimeout(()=>{
        setErrors('')
      },2000)
    }
   
    else{
      const headers = {
        'Authorization': authToken,
      };
    if(isRegisterationTrue) {
      setLoading(true);
      axios.post('https://mfnj3t4tqm.us-east-1.awsapprunner.com/api/uloggedin/user/register-user',
      {
        name:userData?.firstName + userData?.lastName,
        location:userData?.location,
        mobileNumber:userData?.mobileNumber,
        password:data?.newPin
      },{headers}
      )
      .then((resp)=>{
        console.log(resp.data)
        setLoading(false);
        setRegistrationStep(3)
      })
      .catch((err)=>{
        setLoading(false);
        console.log("err",err?.response?.data)
        setErrors(err?.response?.data);
        setTimeout(()=>{
          setErrors('')
        },2000)
      })
    }
    else{
      setLoading(true);
      axios.post('https://mfnj3t4tqm.us-east-1.awsapprunner.com/api/uloggedin/user/update-password',
      {
        phoneNumber:userData?.mobileNumber,
        password:data?.newPin
      },{headers}
      )
      .then((resp)=>{
        console.log(resp.data)
        setLoading(false);
        setForgotPasswordStep(3)
      })
      .catch((err)=>{
        setLoading(false);
        console.log("err",err?.response?.data)
        setErrors(err?.response?.data);
        setTimeout(()=>{
          setErrors('')
        },2000)
      })
    }
  }
  };
  const newPinValue = watch("newPin");

  console.log(watch("example")); // watch input value by passing the name of it
  return (
    <>
      <div className="pin-form-container">
        <TopSection />
        <form className="pin-middle-section" onSubmit={handleSubmit(onSubmit)}>
          {
            isRegisterationTrue ? 
            <h2>Pin Generation</h2>
            :
            <h2>Update Pin</h2>
          }
          <hr />
          <input
            type="text"
            id="newPin"
            name="newPin"
            placeholder="Type 6 digit new pin"
            {...register("newPin", { required: true, maxLength: 6 })}
            className={`input-field ${errors.newPin ? "error-para" : ""}`}
          />
          <input
            type="text"
            id="confirmPin"
            name="confirmPin"
            placeholder="Retype 6 digit new pin"
            {...register("confirmPin", {
              required: true,
              maxLength: 6,
              validate: (value) => value === newPinValue,
            })}
            className={`input-field ${errors.confirmPin ? "error-para" : ""}`}
          />
          <button className="submit-btn" type="submit">
          {loading?'Loading...':  'Submit'}
          </button>
          {
            error &&
            <p style={{marginTop:10,fontSize:13,color:'red'}}>{error}</p>
          }
          <BottomSection />
        </form>
      </div>
    </>
  );
};
